import React from 'react';

import { 
  ChannelNameWrapper,
  ChannelNameContainer,
  ChannelName,
  SectionContainer,
  ChatSearchContent,
  WrapperSearchList,
  EmptyContent
} from './components';
import CollapseableChatHeader from '../CollapseableChatHeader';

import { ChatStreamContext } from '../../../Context/ChatStreamContext';
import ConfigService from "../../../Services/api/Config";
import IconBlue from "../../Common/Icon/blue";
import IconMembers from "../../Common/Icon/members";
import Icon from "../../Common/Icon";
import {ReactComponent as StarIcon} from "../../../../img/icon-star-score.svg";
import {ReactComponent as RoleIcon} from "../../../../img/icon-role.svg";
import {ReactComponent as HouseIcon} from "../../../../img/icon-house.svg";
import {ReactComponent as CircleIcon} from "../../../../img/icon-circle.svg";
import {ReactComponent as MuteIcon} from "../../../../img/icon-sound-off.svg";
import {ReactComponent as DeleteIcon} from "../../../../img/icon-error.svg";

import InputText from '../../../Components/FormFields/Text';
import ModalAddChat from "../ModalAddChat";
import ModalExitChat from "../ModalExitChat";
import History from "../../../Services/History";

class ChatSectionListScreen extends React.Component {
  static contextType = ChatStreamContext;

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      search: '',
      modalAddChat: false,
      modalExit: false,
      customChannelSelected: {},
    };
  }

  componentDidMount() {
    History.singleton().register('modalAddChat', () => {
     this.onPressedAdd();
    }, () => {
     this.onPressedModalAddChatClose();
    });
    History.singleton().register('modalExit', () => {
      this.onPressedExit();
    }, () => {
     this.onPressedModalExitClose();
    });
  }

  componentWillUnmount() {
    History.singleton().unregister('modalAddChat');
    History.singleton().unregister('modalExit');
  }

  onPressedAdd = () => {
    History.singleton().show('modalAddChat');
    this.setState({ modalAddChat: true });
  };

  onPressedModalAddChatClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalAddChat: false });
  };

  
  onPressedModalExitClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalExit: false });
  };

  onPressedExit = (channel) => {
    History.singleton().show('modalExit');
    this.setState({ modalExit: true });
    this.setState({ customChannelSelected: channel });
  };

  exitChannel = () => {
    const { exitDirectChat } = this.context;
    const { customChannelSelected } = this.state;
    exitDirectChat(customChannelSelected);
  };

  onAddChat = async (user) => {
    const { createDirectChat, onSelectChat, getChatChannelData } = this.context;
    const chat = await createDirectChat(user);
    if (chat) {
      chat.dataChat = getChatChannelData(chat);
      onSelectChat(chat);
    }
  };

  searchChatList = async (value) => {
    const { searchChatList } = this.context;
    let list = await searchChatList(value);
    this.setState({
     list: list,
      search: value,
    });
  };

  renderItem = (channel) => {
    const { onSelectChat } = this.props;
    const { checkChannelCustom, getChannelType } = this.context;
    const messageLinkId = channel.messageLink ? '-' + channel.messageLink.id : '';

    return (
      <ChannelNameWrapper
        key={channel.id + messageLinkId}
        textColor={ ConfigService.getColor('primaryColor') }
        backgroundColor={ 'white' }
        backgroundColorHover={ ConfigService.getColor('tertiaryColor', 0.2) }
      >
        <ChannelNameContainer onClick={() => onSelectChat(channel)}>
          { ((getChannelType(channel) !== 'group')) &&
            <Icon
              width='10'
              height='10'
              changeColor={!checkChannelCustom(channel) ? 'primaryColor' : 'secondaryColor'}
              color={this.getColorIconChannel(channel)}
            >
            {
              ['role', 'vendor', 'resident'].includes(getChannelType(channel)) &&
              <RoleIcon alt='icon-role'/>
            ||
              ['property', 'portfolio'].includes(getChannelType(channel)) &&
              <HouseIcon alt='icon-house'/>
            ||
              <CircleIcon alt='icon-circle'/>
            }
            </Icon>
          ||
           <IconMembers members={this.getNumMembers(channel)}/>
          }
          <ChannelName>
            {channel.dataChat.viewChatName}
            { channel.messageLink &&
              <span>({channel.messageLink.text})</span>
            }
          </ChannelName>
        </ChannelNameContainer>
      </ChannelNameWrapper>
    )
  };

  getNumMembers = (channel) => {
    return channel && channel.dataChat ? channel.dataChat.memberNumber : 0;
  };

  getUnreadMessages = (channel) => {
    return channel && channel.dataChat ? channel.dataChat.messagesUnread : 0;
  };

  getUnreadMessagesSection = (data) => {
    let numMessagesSection = 0;
    data.map( (channel) => {
      numMessagesSection += this.getUnreadMessages(channel);
    });
    return numMessagesSection;
  };

  getColorIconChannel = (channel) => {
    const { checkChannelCustom, currentUser } = this.context;
    let online = false;
    if (!checkChannelCustom(channel)) {
      return 'primaryColor';
    }
    else {
      Object.keys(channel.state.members).forEach((key) => {
        const user = channel.state.members[key] ? channel.state.members[key].user : {};
        if (currentUser && (currentUser.id !== user.id) && user.online) {
          online = true;
        }
      });
      return online ? 'successColor' : 'errorColor';
    }
  };

  renderSectionHeader = ({ title, data }) => {
    const { onSelectChat } = this.props;
    const { getChannelType, checkChannelCustom } = this.context;

    const numMessagesSection = this.getUnreadMessagesSection(data);

    const section = (
      <SectionContainer>
        {data.map((channel, index) => (
          <ChannelNameWrapper 
            key={channel.id}
            textColor={ ConfigService.getColor('primaryColor') }
            backgroundColor={ 'white' }
            backgroundColorHover={ ConfigService.getColor('tertiaryColor', 0.2) }
          >
            <ChannelNameContainer onClick={() => onSelectChat(channel)}>
              { ((getChannelType(channel) !== 'group')) &&
                <Icon
                  width='10'
                  height='10'
                  changeColor={!checkChannelCustom(channel) ? 'primaryColor' : 'secondaryColor'}
                  color={this.getColorIconChannel(channel)}
                >
                  {
                    ['role', 'vendor', 'resident'].includes(getChannelType(channel)) &&
                    <RoleIcon alt='icon-role'/>
                  ||
                    ['property', 'portfolio'].includes(getChannelType(channel)) &&
                    <HouseIcon alt='icon-house'/>
                  ||
                    <CircleIcon alt='icon-circle'/>
                  }
                </Icon>
              ||
               <IconMembers members={this.getNumMembers(channel)}/>
              }
              <ChannelName>
                {channel.dataChat.viewChatName}
              </ChannelName>
              { channel.muteStatus().muted &&
                <Icon className='IconMute' width='15' height='15' color='primaryColor'>
                  <MuteIcon alt='icon-mute'/>
                </Icon>
              }
              { this.getUnreadMessages(channel) > 0 &&
                <IconBlue>{this.getUnreadMessages(channel)}</IconBlue>
              }
            </ChannelNameContainer>
            { checkChannelCustom(channel) &&
              <Icon onClick={() => this.onPressedExit(channel)} className='IconDelete' width='15' height='15' color='primaryColor'>
                <DeleteIcon alt='icon-delete'/>
              </Icon>
            }
          </ChannelNameWrapper>
        ))}
      </SectionContainer>
    );

    return (
      <CollapseableChatHeader
        key={title}
        sectionTitle={title} 
        section={section}
        numMessages={numMessagesSection}
        onAddChat={this.onPressedAdd}
      />
    )
  };

  render () {
    const { searchUserList, searchRecentList } = this.context;
    const { chatList } = this.props;
    const { list, search, modalAddChat, modalExit } = this.state;

    if (!chatList) {
      return null;
    }

    return (
      <>
        <ChatSearchContent borderColor={ ConfigService.getColor('tertiaryColor', 0.3) }>
          <InputText className='Input-Search' placeholder='Search' onChange={ (v) => this.searchChatList(v) }/>
        </ChatSearchContent>
        {list.length > 0 &&
          <WrapperSearchList>
            {list.map((channel) => this.renderItem(channel))}
          </WrapperSearchList>
        }
        { list.length === 0 && search &&
          <EmptyContent borderColor={ ConfigService.getColor('tertiaryColor', 0.3) }>
            No results found...
          </EmptyContent>
        }
        { list.length === 0 && !search &&
          <div>
            {chatList.map((section) => this.renderSectionHeader(section))}
          </div>
        }
        { modalAddChat && (
          <ModalAddChat
            onClose={ this.onPressedModalAddChatClose }
            onSubmit={ this.onAddChat }
            searchUserList={ searchUserList }
            searchRecentList={ searchRecentList }
          />
        ) }
        { modalExit && (
          <ModalExitChat
            onClose={ this.onPressedModalExitClose }
            onSubmit={ this.exitChannel }
          />
        ) }
      </>
    )
  }
}

export default React.memo(ChatSectionListScreen);